import { TableName } from '@/enums/tableName.enum';
import { Filter } from '@/interfaces/filters/filter';
import { Presence } from '@/interfaces/presence';
import { presenceResource, PresenceResource } from '@/resources/presence.resource';
import { EntityModule } from './entity.module';

/**
 * Moduł list obecności
 *
 * @export
 * @class PresencesModule
 * @extends { EntityModule<Presence, PresenceResource> }
 */
export class PresencesModule extends EntityModule<Presence, PresenceResource> {
  constructor() {
    super(presenceResource);

    this.state = {
      ...this.state,
      entityType: undefined,
      entityId: undefined
    };

    this.actions = {
      ...this.actions,
      /**
       * Aktualizuje encję
       *
       * @param context context
       * @param data dane encji
       */
      update: async (context: any, data: any): Promise<void> => {
        await this.resource.update(data.id as number, data);
        data.scheduleContainer = { id: data.scheduleContainerId };
        delete data.scheduleContainerId;
        delete data.presentPlayersIds;
        context.commit('setEntity', data);
      },
      /**
       * Pobiera listę encji
       *
       * @param context context
       * @param filters filtry listy
       */
      list: async (context: any, filters: Filter): Promise<void> => {
        const pagination = {
          ...filters,
          entityId: context.state.entityId,
          entityType: context.state.entityType
        };
        const { list, count } = await this.resource.list(pagination);
        context.commit('saveList', list);
        context.commit('saveCount', count);
      }
    };

    this.mutations = {
      ...this.mutations,
      /**
       * Ustawia rodzaj encji
       *
       * @param {*} localState
       * @param {TableName} entityType
       */
      setEntityType(localState: any, entityType: TableName): void {
        localState.entityType = entityType;
      },
      /**
       * Ustawia id encji
       *
       * @param {*} localState
       * @param {number} entityId
       */
      setEntityId(localState: any, entityId: number): void {
        localState.entityId = entityId;
      }
    };
  }
}

export default new PresencesModule();
